const PIXEL_ID = '2190085458428751'

let pixelLoaded = false

export function initMetaPixel(): void {
  if (pixelLoaded || typeof window === 'undefined') return
  pixelLoaded = true

  // Initialize fbq function before script loads
  const fbq = function (...args: any[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  } as any
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as any[]
  ;(window as any).fbq = fbq
  ;(window as any)._fbq = (window as any)._fbq || fbq

  // Inject the Facebook pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Init pixel and fire PageView
  ;(window as any).fbq('init', PIXEL_ID)
  ;(window as any).fbq('track', 'PageView')

  // Also add noscript fallback image
  const noscriptImg = document.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscriptImg)
}

export function trackAddToCart(): void {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart')
  }
  // Also fire via image pixel as fallback (ensures it fires before navigation)
  const img = new Image()
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=AddToCart&noscript=1`
}
